import { render, staticRenderFns } from "./reportedAndDiscarded.vue?vue&type=template&id=53e51bde&"
import script from "./reportedAndDiscarded.vue?vue&type=script&lang=js&"
export * from "./reportedAndDiscarded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports